import { getCountryForTimezone } from "countries-and-timezones"
import App from "./App.svelte"

let appContainer = document?.getElementById("appContainer")

const hydrate = true //import.meta?.env?.MODE !== "development"
console.log("Features: ", { hydrate })

// get the default country by region for the user's timezone only in browser, not in ssr
// @ts-ignore
window._defaultCountry =
    new Intl.Locale(window.navigator.language).region ||
    getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)?.id
// @ts-ignore
console.log("Default country: ", window._defaultCountry)

const app = new App({
    target: appContainer,
    props: {},
    hydrate,
})

export default app
